'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { Text } from '../text/text';
import { ToggleButtonRootContext } from './context/toggle-button-root.context';
import { toggleButtonLabelRecipe } from './styles/toggle-button-label.styles';
import type { ToggleButtonLabelPropsInterface } from './types/toggle-button-label.types';

/**
 * @since 10.0.0
 */
export const ToggleButtonLabel = forwardRef<HTMLSpanElement, ToggleButtonLabelPropsInterface>(
  (props: ToggleButtonLabelPropsInterface, forwardedRef) => {
    const {
      disabled = false,
      size = 'sm',
      selected = false,
      loading = false,
    } = useContext(ToggleButtonRootContext);
    const { css: cssProp, ...rest } = props;

    return (
      <Text
        ref={forwardedRef}
        data-c11n-component="ToggleButton.Label"
        data-c11n-version={__C11N_VERSION__}
        css={css.raw(toggleButtonLabelRecipe.raw({ disabled, selected, size, loading }), cssProp)}
        {...rest}
        className={cx('c11n_toggle-button__label', rest.className)}
      />
    );
  },
);

ToggleButtonLabel.displayName = 'ToggleButton.Label';
